import React, { useEffect, useState } from 'react';
import Popover from 'react-bootstrap/Popover';
import Button from './../../components/common/Button';
import CheckboxComponent from './../../components/common/CheckBox';

interface dropDownkeyType {
  name: string;
  key: string;
  sortable: boolean;
  filterRequired: boolean;
  filterDefault: boolean;
}

interface OverlayComponentProps {
  dropDownKeys: dropDownkeyType[],
  onChange: (list: any) => void,
  checkboxValue: any,
}

const OverlayComponent = ({
  dropDownKeys,
  onChange,
  checkboxValue,
}: OverlayComponentProps) => {
  const [list, setList] = useState({ ...checkboxValue });
  
  useEffect(() => {
    setList({ ...checkboxValue });
  }, [checkboxValue]);

  const handleChange = (checked: boolean, checkboxName: string) => {
    setList((preValue: any) => {
      return {
        ...preValue,
        [checkboxName]: checked,
      };
    });
  };

  return (
    <Popover id="user-overlay-tooltip" placement="auto-start">
      <Popover.Header as="h6">Select Parameters to View</Popover.Header>
      <Popover.Body>
        <div className="user-checkBox-group">
          {dropDownKeys.map((checkboxName) => {
            return (
              <>
                <CheckboxComponent
                  className=""
                  checkBoxName={checkboxName.name}
                  disabled={false}
                  onCheckboxChange={(checked) =>
                    handleChange(checked, checkboxName.key)
                  }
                  placeCheckboxBefore={false}
                  isChecked={list[checkboxName.key]}
                />
              </>
            );
          })}
          <Button
            onClick={() => onChange(list)}
            disabled={false}
            id="overlay-tooltip-save"
            buttonName={'Save'}
            colorType={'primary'}
          />
        </div>
      </Popover.Body>
    </Popover>
  );
};

export default OverlayComponent;
